export const circlesHorizontalAnimationInit = (svg, tl) => {
  const ringOne = svg.children[0];
  const ringTwo = svg.children[1];
  const ringThree = svg.children[2];
  tl.set(ringOne, {
    x: -10,
    opacity: 0,
  })
    .set(ringTwo, {
      opacity: 0,
    })
    .set(ringThree, {
      x: 10,
      opacity: 0,
    });
  return { ringOne, ringTwo, ringThree };
};
export const circlesHorizontalAnimation = (elements, tl) => {
  const { ringOne, ringTwo, ringThree } = elements;

  tl.to([ringOne, ringTwo, ringThree], {
    duration: 1,
    x: 0,
    opacity: 1,
    ease: "back.out(1.7)",
  });
};
